import { render, staticRenderFns } from "./PgaOrderRequirementsReviewCreate.vue?vue&type=template&id=64f293b8&"
import script from "./PgaOrderRequirementsReviewCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOrderRequirementsReviewCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f293b8')) {
      api.createRecord('64f293b8', component.options)
    } else {
      api.reload('64f293b8', component.options)
    }
    module.hot.accept("./PgaOrderRequirementsReviewCreate.vue?vue&type=template&id=64f293b8&", function () {
      api.rerender('64f293b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/create/sections/PgaOrderRequirementsReviewCreate.vue"
export default component.exports